export default {
  通话明细: '通话明细',
  通话视角: '通话视角',
  人员视角: '人员视角',
  下载: '下载',
  查看录音: '查看录音',
  查看详情: '查看详情',
  数据概览: '数据概览',
  通话时长: '通话时长',
  接通次数: '接通次数',
  有效通话数: '有效通话数',
  无效通话数: '无效通话数',
  电话总数: '电话总数',
  通话时间大于等于1分钟: '通话时间大于等于1分钟',
  通话时间小于1分钟: '通话时间小于1分钟',
  已接通和未接通的电话总数: '已接通和未接通的电话总数',
  日程明细: '日程明细',
  日程视角: '日程视角',
  会议妙记: '会议妙记',
  申请入会: '申请入会',
  跟进方式: '跟进方式',
  该线索已删除: '该线索已删除',
  日程: '日程',
  日程数: '日程数',
  开始时间升序: '开始时间升序',
  开始时间降序: '开始时间降序',
  结束时间升序: '结束时间升序',
  结束时间降序: '结束时间降序',
  重点: '重点',
  暂无数据: '暂无数据',
  通话记录: '通话记录',
  拨打时间升序: '拨打时间升序',
  拨打时间降序: '拨打时间降序',
  通话时长升序: '通话时长升序',
  通话时长降序: '通话时长降序',
  创建日程: '创建日程',
  线索: '线索',
  通话: '通话',
  日程总数: '日程总数',
  未开始日程: '未开始日程',
  进行中日程: '进行中日程',
  已结束日程: '已结束日程',
  日程开始时间: '日程开始时间',
  日程结束时间: '日程结束时间',
  日程创建时间: '日程创建时间',
  管理员: '管理员',
  普通座席: '普通座席',
  '输入日程主题/客户名称': '输入日程主题/客户名称',
  动态记录视角: '动态记录视角',
  人员视角切换: '人员视角切换',
  妙计链接: '妙计链接',
  动态记录创建时间: '动态记录创建时间',
  动态记录数量: '动态记录数量',
  '输入客户名称/跟进详情': '输入客户名称/跟进详情'
};
